<template>
  <section>
    <!-- Introduction -->
    <v-row>
      <v-col cols="12">
        <p>
          Southwold is a little touristic town in the south east of England. Know for its colourful huts next to the sea and its famous brewery Adnams, Southwold is a typical English village.
        </p>
      </v-col>
    </v-row>
    <!-- Gallery -->
    <v-row>
      <v-col cols="12">
        <PortfolioGallery :img="list" />
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data: () => {
    return {
      list: [
        {
          link: "/img/photos/England/Bayview.jpg",
          title: "Viking's sunset",
          description: null
        },
        {
          link: "/img/photos/England/cabanons.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/carrés.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/la vieille angleterre se couche.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/Lifa saving.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/mer calme et sombre.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/pier couché soleil.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/England/Under the pier.jpg",
          title: "A star in the sky",
          description: null
        },
      ]
    };
  },

  created() {
    this.$store.commit('SET_GALLERY_DATA', this.list)
  }
};
</script>

<style></style>
